export default __webpack_public_path__ + "static/media/problem_1.48b9e34a.gif";